import { NumberField, SelectField, useFormContext, useFormField } from '@calendly/form';
import { usePrevious } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { RadioInput } from '@calendly/ui/components/radio-input';
import { useIsControl } from '@calendly/ui/components/select';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useCallback, useEffect, forwardRef } from 'react';
import { OptionContainer } from './option_container';
const radioContainerCss = "r7cxvbv";
const RadioContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(radioContainerCss, props.className)} />;
});
const containerCompactCss = "cfqujc0";
const containerIsPhoneCss = "cn9ccem";
const containerIsTabletUpCss = "c1run85v";
const containerCss = "c1942p3v";
const Container = forwardRef((props, ref) => {
  const {
    compact,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerCompactCss]: compact,
    [containerIsPhoneCss]: isPhone,
    [containerIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const rightLabelCompactCss = "r14lwbi";
const rightLabelIsPhoneCss = "rgu4fiz";
const rightLabelCss = "reun3er";
const RightLabel = forwardRef((props, ref) => {
  const {
    compact,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(rightLabelCss, {
    [rightLabelCompactCss]: compact,
    [rightLabelIsPhoneCss]: isPhone
  }, props.className)} />;
});
const styledSelectFieldCss = "svjh367";
const StyledSelectField = forwardRef((props, ref) => <SelectField ref={ref} {...props} className={classNames(styledSelectFieldCss, props.className)} />);
const optionHelpCss = "o1etpgxz";
const OptionHelp = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionHelpCss, props.className)} />;
});
const styledLabelCss = "s1m538s1";
const StyledLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(styledLabelCss, props.className)} />;
});
const Option = ({
  value
}) => {
  const isControl = useIsControl();
  const firstLine = {
    calendar: I18n.t('publisher.event_types.availability.calendar_days'),
    business: I18n.t('publisher.event_types.availability.weekdays')
  }[value];
  if (isControl) return firstLine;
  const secondLine = {
    calendar: <OptionHelp>{I18n.t('publisher.event_types.availability.calendar_days_help')}</OptionHelp>,
    business: <OptionHelp>{I18n.t('publisher.event_types.availability.weekdays_help')}</OptionHelp>
  }[value];
  return <div>
      {firstLine}
      {secondLine}
    </div>;
};
const RangeValueInputs = ({
  disabled
}) => {
  const {
    values: {
      movingType
    },
    setFieldValue,
    setFieldTouched
  } = useFormContext();
  const previousValue = usePrevious(movingType);
  useEffect(() => {
    if (!previousValue || previousValue === movingType) return;
    setFieldValue('periodType', 'rollingDays');
    setFieldTouched('periodType', true);
  }, [movingType, previousValue, setFieldTouched, setFieldValue]);
  return <NumberField name="maxBookingTime" aria-label={I18n.t('publisher.event_types.availability.range_of_dates_label')} disabled={disabled}>
      <StyledSelectField aria-label={I18n.t('publisher.event_types.availability.type_of_days_label')} disabled={disabled} name="movingType" options={['calendar', 'business'].map(value => ({
      value,
      name: <Option value={value} />
    }))} />
    </NumberField>;
};
const RadioField = ({
  compact
}) => {
  const [fieldProps] = useFormField({
    name: 'periodType',
    value: 'rollingDays',
    type: 'radio'
  });
  const originalOnChange = fieldProps.onChange;
  const onChange = useCallback((_, event) => originalOnChange(event), [originalOnChange]);
  return <Container compact={compact}>
      <RadioContainer>
        <StyledLabel>
          <RadioInput {...fieldProps} id="intoTheFuture" onChange={event => onChange(fieldProps.value, event)} />
        </StyledLabel>
        <RangeValueInputs compact={compact} />
      </RadioContainer>
      <RightLabel compact={compact} htmlFor="intoTheFuture">{I18n.t('publisher.event_types.availability.moving_period_label')}</RightLabel>
    </Container>;
};
export const MovingOption = ({
  compact = false,
  spaceless = false
}) => {
  const {
    values: {
      periodType
    },
    setFieldError
  } = useFormContext();
  useEffect(() => {
    setFieldError('maxBookingTime', undefined);
  }, [periodType, setFieldError]);
  return <OptionContainer spaceless={spaceless}>
      <RadioField compact={compact} />
    </OptionContainer>;
};

require("./moving_option.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./moving_option.js");